import React from "react";
const SvgDsGoogle = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="#4285F4"
        d="M21.604 12.23c0-.68-.055-1.363-.172-2.032H12v3.85h5.4a4.628 4.628 0 01-1.998 3.04v.002l.004-.003 3.22 2.497c1.891-1.741 2.978-4.313 2.978-7.354z"
      />
      <path
        fill="#34A853"
        d="M18.626 19.584l-3.22-2.497-.004.003c-.896.608-2.052.953-3.399.953-2.608 0-4.82-1.76-5.614-4.127h-.004l-3.321 2.576A10.001 10.001 0 0012 22c2.697 0 4.971-.886 6.628-2.414l-.002-.002z"
      />
      <path
        fill="#FBBC04"
        d="M6.385 10.088L3.064 7.512a10.008 10.008 0 000 8.98l3.321-2.576a5.99 5.99 0 010-3.828z"
      />
      <path
        fill="#EA4335"
        d="M12 2a9.998 9.998 0 00-8.936 5.512l3.321 2.576c.79-2.37 3.006-4.13 5.615-4.13a5.434 5.434 0 013.836 1.499l2.855-2.855A9.61 9.61 0 0012 2.001z"
      />
    </g>
  </svg>
);
export default SvgDsGoogle;
